import { useInfiniteQuery, UseInfiniteQueryOptions } from '@lumapps/base-api/react-query';

import { list, ListAPIParams, templateQueryKeys } from '../api';

export const useContentTemplatesQuery = (params: ListAPIParams, options?: UseInfiniteQueryOptions) => {
    return useInfiniteQuery({
        ...options,
        queryKey: templateQueryKeys.list(params),
        queryFn: ({ signal, pageParam }) => list({ ...params, cursor: pageParam }, signal),
        getNextPageParam: (lastPage) => lastPage?.more && lastPage?.cursor,
    });
};
